import React, { useEffect, useMemo, useState } from "react";
import './App.css';

import FiltersBlock from "./components/FiltersBlock";
import SpecialistsList from "./components/SpecialistsList";
import SpecialistModal from "./components/SpecialistModal";
import Footer from "./components/Footer";
import FooterNav from "./components/FooterNav";
import FavoritesPage from "./components/FavoritesPage";
import AboutPage from "./components/AboutPage";
import AddressesPage from "./components/AddressesPage";
import ForPsychologists from "./components/ForPsychologists";
import getFilters from "./api/get-filters";
import getSpecialists from "./api/get-specialists";
import CookieNotice from "./components/CookieNotice";


function App() {
    const [allSpecialists, setAllSpecialists] = useState([]);
  const [specialists, setSpecialists] = useState([]);
  const [problemFilters, setProblemFilters] = useState([]);
  const [locationFilters, setLocationFilters] = useState([]);
  const [filter, setFilter] = useState(null);
  const [location, setLocation] = useState(null);
  const [selected, setSelected] = useState(null);
  const [index, setIndex] = useState(0);
  const [hasVideo, setHasVideo] = useState(false);

  const [likes, setLikes] = useState(() => {
    return JSON.parse(localStorage.getItem("likes") || "[]");
  });

  useEffect(() => {
    getSpecialists(filter, location)
        .then(res => {
          setSpecialists(res.data);
        })
        .catch(e => {
          console.error(e);
        })
  }, [filter, location]);

  const toggleLike = (id) => {
    setLikes(prev => {
      let updated;
      if (prev.includes(id)) {
        updated = prev.filter(x => x !== id);
      } else {
        updated = [...prev, id];
      }
      localStorage.setItem("likes", JSON.stringify(updated));
      return updated;
    });
  };

  // ---------------------- НАВИГАЦИЯ ----------------------
  const [page, setPage] = useState("home");

  // ---------------------- ЗАГРУЗКА СПЕЦИАЛИСТОВ ----------------------
  useEffect(() => {
    getFilters()
        .then(f => {
          setProblemFilters(f.problems);
          setLocationFilters(f.locations);
        })
        .catch(e => {
          console.error(e);
        })

      getSpecialists(filter, location)
          .then(res => {
              setSpecialists(res.data);
          })
          .catch(e => {
              console.error(e);
          })

      getSpecialists(null, null)
          .then(res => {
              setAllSpecialists(res.data);
          })
          .catch(e => {
              console.error(e);
          })
  }, []);

  // ---------------------- ФИЛЬТРАЦИЯ ----------------------
  const filtered = filter === null
    ? specialists
    : specialists.filter(s => s
        //s.skill.trim().toLowerCase().includes(filter.trim().toLowerCase())
      );

  // ---------------------- ВИДЕО ----------------------
  const isVideo = (src) =>
    typeof src === "string" &&
    src.toLowerCase().includes("/video/");

  const probeVideo = (src) =>
    new Promise((resolve) => {
      try {
        const v = document.createElement('video');
        v.src = src;
        v.preload = 'metadata';
        v.onloadeddata = () => resolve(true);
        v.onerror = () => resolve(false);
        setTimeout(() => resolve(false), 5000);
        v.load();
      } catch {
        resolve(false);
      }
    });

  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      if (!selected) {
        setHasVideo(false);
        return;
      }
      const materials = JSON.parse(selected.materials);
      const videoSrc = materials.find(isVideo);
      if (!videoSrc) {
        setHasVideo(false);
        return;
      }
      const ok = await probeVideo(videoSrc);
      if (!cancelled) setHasVideo(ok);
    };
    check();
    return () => { cancelled = true; };
  }, [selected]);

  const displayed = useMemo(() => {
    if (!selected) return [];
    const materials = JSON.parse(selected.materials);
    const photos = materials.filter(src => !isVideo(src));
    const videoSrc = materials.find(isVideo);
    return hasVideo && videoSrc ? [...photos, videoSrc] : photos;
  }, [selected, hasVideo]);

  const nextMaterial = () => {
    if (!selected || displayed.length === 0) return;
    setIndex((prev) => (prev + 1) % displayed.length);
  };

  const prevMaterial = () => {
    if (!selected || displayed.length === 0) return;
    setIndex((prev) => (prev - 1 + displayed.length) % displayed.length);
  };

  // ---------------------- РЕНДЕР ----------------------
  return (
    <div style={{ padding: "20px", paddingBottom: "80px" }}>
      
      {/* Логотип */}
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <img 
          src="/images/logo-new.jpg"
          alt="Логотип БЛИЗКО" 
          style={{ width: "16.6%", minWidth: "192px", minHeight: '192px' }}
        />
      </div>

      <p style={{ textAlign: 'center' }}><a href='tel:79780952060' style={{ fontWeight: 'bold', textAlign: "center", color: '#213c2e', textDecoration: 'none' }}>+7 978 095-20-60</a></p>


      {/* ---------------------- СТРАНИЦЫ ---------------------- */}

      {page === "home" && (
        <>
            <div style={{
                margin: 'auto',
                width: '60%'
            }}>
                <FiltersBlock
                    filter={filter}
                    setFilter={setFilter}
                    problemFilters={problemFilters}
                    location={location}
                    setLocation={setLocation}
                    locationFilters={locationFilters}
                />
            </div>

          <SpecialistsList
            specialists={filtered}
            onSelect={(s) => { setSelected(s); setIndex(0); }}
            likes={likes} 
            toggleLike={toggleLike}
          />
        </>
      )}

      {page === "favorites" && (
        <FavoritesPage
          specialists={allSpecialists}
          onSelect={(s) => { setSelected(s); setIndex(0); }}
          likes={likes}
          toggleLike={toggleLike}
        />
      )}

      {page === "addresses" && <AddressesPage />}
      {page === "for-psychologists" && <ForPsychologists />}
      {page === "about" && <AboutPage setPage={setPage} />}



      {/* ---------------------- МОДАЛКА СПЕЦИАЛИСТА ---------------------- */}

      <SpecialistModal
        selected={selected}
        displayed={displayed}
        index={index}
        setIndex={setIndex}
        prevMaterial={prevMaterial}
        nextMaterial={nextMaterial}
        isVideo={isVideo}
        setSelected={setSelected}
        likes={likes} 
        toggleLike={toggleLike}
      />

      {/* ---------------------- ПОДВАЛ ---------------------- */}
      <CookieNotice />

      <Footer />

      <FooterNav setPage={setPage} page={page} />
    </div>
  );
}

export default App;
